import styled from "styled-components";
import Colors from "../../themes/Colors";
import Fonts from "../../themes/Fonts";
import { fadeIn } from "../Common/CommonStyles";

export const MainNavbar = styled.nav`
  background-color: ${(props) =>
    props?.backGroundColor || Colors.primaryHumano};
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  height: ${(props) => props.height || "50px"};
  @media screen and (max-width: 844px) {
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 480px) {
    height: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const MainUserContent = styled.span`
  margin-right: 1rem;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  font-style: normal;
  @media (max-width: 480px) {
    font-size: 9px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const MainIconContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const MainIcon = styled.i`
  margin-right: 0.5rem;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  font-style: normal;
`;

export const MainDropdown = styled.div`
  position: relative;
`;

export const MainDropdownButton = styled.button`
  background: none;
  border: none;
  color: inherit;
  cursor: pointer;
`;

export const MainDropdownMenu = styled.div`
  z-index: 999;
  position: absolute;
  top: 100%;
  right: 0;
  background-color: ${Colors.grayClean};
  padding: 0.5rem;
  display: block;
  min-width: 100px;
  white-space: nowrap;
  ${MainDropdown}:hover & {
    display: block;
  }
  &:hover {
    background-color: ${(props) =>
      props?.backGroundHover || Colors.primaryPrimera};
  }

  @media screen and (max-width: 844px) {
    position: static;
    animation: ${fadeIn} 0.5s ease-in;
    display: none;
    ${MainDropdown}:hover & {
      display: block;
    }
`;

export const MainMenuItem = styled.a`
  display: block;
  color: black;
  text-decoration: none;
  padding: 0.5rem;
  font-family: ${(props) => props.font || Fonts.familyVerlag};
  font-style: normal;
  cursor: ${(props) => (props.onClick ? "pointer" : "default")};
  white-space: nowrap;
  width: 100%;
  @media screen and (max-width: 844px) {
    margin-bottom: 1rem;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const MenuNavbar = styled.nav`
  background-color: white;
  display: flex;
  align-items: center;
  padding: 1rem;
  height: ${(props) => props.height || "20px"};

  @media screen and (max-width: 844px) {
    flex: 1;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }

  @media (max-width: 480px) {
    height: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const Logo = styled.img`
  width: ${(props) => props.width || "200px"};
  height: ${(props) => props.height || "auto"};
  margin-left: 150px;
  @media (max-width: 320px) {
    width: 100px;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const Menu = styled.ul`
  display: flex;
  list-style: none;
  margin-left: auto;

  @media screen and (max-width: 844px) {
    margin-top: 1rem;
    flex-direction: column;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const MenuItem = styled.li`
  margin-right: 1rem;
  position: relative;

  &:hover {
    cursor: pointer;
  }

  @media screen and (max-width: 844px) {
    margin-bottom: 1rem;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const DropdownMenu = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  background-color: white;
  padding: 0.5rem;
  display: ${({ isOpen }) => (isOpen ? "block" : "none")};

  @media screen and (max-width: 844px) {
    position: static;
    display: ${({ isOpen }) => (isOpen ? "block" : "none")};
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const DropdownMenuItem = styled.li`
  margin-top: 0.1rem;
  justify-content: center;
  display: flex;
  flex: 1;
  width: 150px;
  background-color: ${Colors.grayClean};
  &:hover {
    background-color: ${(props) =>
      props?.backGroundHover || Colors.primaryPrimera};
    cursor: pointer;
  }
  @media (max-width: 844px) {
    width: auto;
    animation: ${fadeIn} 0.5s ease-in;
  }
`;

export const HeaderStyles = {
  dimensionLogoPrimera: {
    width: "200px",
    height: "auto",
  },
  dimensionLogoHumano: {
    width: "185px",
    height: "55px",
  },
};